// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Ip-z","selected":"Jp-z"};